module.exports = __webpack_public_path__ + "media/images/diving-board-984d6108280ba0a9a93a97ee28474571.jpg";